module.exports = __webpack_public_path__ + "components/breakheader/static/icon--s0-450d82287faa3d9ffe416c889d6229a1.svg";